import { render } from "./RescheduleActivities.vue?vue&type=template&id=5204a59a&scoped=true"
import script from "./RescheduleActivities.vue?vue&type=script&lang=js"
export * from "./RescheduleActivities.vue?vue&type=script&lang=js"

import "./RescheduleActivities.vue?vue&type=style&index=0&id=5204a59a&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5204a59a"]])

export default __exports__